import { render, staticRenderFns } from "./WhistleBlowing.vue?vue&type=template&id=79201ecb&scoped=true&"
import script from "./WhistleBlowing.vue?vue&type=script&lang=js&"
export * from "./WhistleBlowing.vue?vue&type=script&lang=js&"
import style0 from "./WhistleBlowing.vue?vue&type=style&index=0&id=79201ecb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79201ecb",
  null
  
)

export default component.exports